import type { Tone } from '../../components/ui/index.js';

/**
 * How a derived work-order status is coloured.
 *
 * WRITTEN ONCE, USED BY EVERY WORK-ORDER SCREEN. The list and the file must
 * not colour the same fact differently, and a `partially_complete` request
 * must never wear the same green as a complete one — a reader scanning a
 * column of badges reads the colour before the word.
 *
 * `partially_complete` is deliberately `info`, not `success`. Some of the work
 * being finished is a real fact worth showing, and it is not the same fact as
 * the job being done (CLAUDE.md section 8).
 */
export function toneForWorkOrderStatus(status: string): Tone {
  if (status === 'complete') return 'success';
  if (status === 'cancelled') return 'warning';
  if (status === 'partially_complete') return 'info';
  if (status === 'in_progress') return 'info';
  // D278: waiting on the client's material.
  if (status === 'awaiting_sample') return 'waiting';
  // Anything a later phase adds that this has not been
  // taught yet. Neutral is the honest default: it claims nothing.
  return 'neutral';
}

/**
 * How the state of ONE requested service is coloured.
 *
 * `complete` here means that one service is finished. It carries no claim
 * about the request as a whole, which is why the two functions are separate
 * rather than one shared table.
 */
export function toneForServiceState(state: string): Tone {
  if (state === 'complete') return 'success';
  if (state === 'cancelled') return 'warning';
  if (state === 'in_progress') return 'info';
  return 'neutral';
}
